// import userStore from '@/utils/userStore';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Autoplay } from 'swiper/modules';
import ChatgptComponent from "@/components/Chatgpt/Chatgpt.jsx";
// 导入 Swiper 的样式
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


import leftgame from '@/assets/leftgame.png';
import rightgame from '@/assets/rightgame.png';
import Subtract from '@/assets/Subtract.png';
import wfj from '@/assets/wfj.png';
import hot from '@/assets/hot.gif';
import slidecon from '@/assets/slidecon.gif';
import topgames from '@/assets/gamesicon/topgames.png';
import hottest from '@/assets/gamesicon/hottest.png';
import trending from '@/assets/gamesicon/trending.png';
import latest from '@/assets/gamesicon/latest.png';
import tcat from '@/assets/lunbo/tcat.png';
import bitball from '@/assets/lunbo/bitball.png';
import num1 from '@/assets/gamesicon/1.png';
import num2 from '@/assets/gamesicon/2.png';
import num3 from '@/assets/gamesicon/3.png';
import { getGameList } from '@/api/apiMethods.js';
import WebApp from '@twa-dev/sdk';
function Games() {
    const [GameItems, setGameItems] = useState([]);
    const [TopGameItems, setTopGameItems] = useState([]);
    const [HottestGameItems, setHottestGameItems] = useState([]);
    const [LatestGameItems, setLatestGameItems] = useState([]);
    const [TrendingGameItems, setTrendingGameItems] = useState([]);
    const fetchGameData = async () => {
        try {
            const getList = await getGameList();
            const topGames = getList?.games_list?.filter(game => game.source === 'top_games') || [];
            const hottestGames = getList?.games_list?.filter(game => game.source === 'hottest') || [];
            const latestGames = getList?.games_list?.filter(game => game.source === 'latest') || [];
            const trendingGames = getList?.games_list?.filter(game => game.source === 'trending') || [];
            setTrendingGameItems(trendingGames);
            setLatestGameItems(latestGames);
            setTopGameItems(topGames);
            setHottestGameItems(hottestGames);
            setGameItems(getList?.games_list || []);
            console.log(topGames, 'topGames');
        } catch (error) {
            console.log(error);
        }
    };
    const toUrl = (url) => {
        if (url.includes('t.me')) {
            if (url == 'https://t.me/BitBallGameBot') {
                window.open("https://game.bitball.io", "_blank")
            } else {
                WebApp.openTelegramLink(url);
            }
        } else {
            WebApp.openLink(url, { try_instant_view: true });
        }
    };
    useEffect(() => {
        fetchGameData();
    }, []);

    return (
        <div className="relative">
            {/* <img
                src={leftgame}
                alt="Left Icon"
                className="absolute left-[-1rem] top-[12rem] transform -translate-y-1/2 w-72 h-72 sm:block hidden"
            />
            <img
                src={rightgame}
                alt="Right Icon"
                className="absolute right-[-1rem] top-[20rem] transform -translate-y-1/2 w-72 h-72 sm:block hidden"
            />

            <img
                src={Subtract}
                alt="Bottom Right Icon"
                className="absolute right-[-1rem] bottom-[5rem]  w-[221.78px] h-[237.7px] sm:block hidden"
            /> */}
            <div className="flex justify-center h-auto">
                {/* <div className="w-full max-w-screen-xl flex flex-col  lg:p-8">
                    <div className="flex flex-col items-start justify-center lg:ml-20 ml-2 z-[9]">
                        <p className="text-white text-4xl">Games</p>
                        <p className="w-[111px] h-[31px] bg-[#2631fb] mt-2 flex items-center justify-center text-white">
                            Games:  {GameItems ? GameItems.length : 0}
                        </p>
                    </div>

                    <div className="flex flex-wrap gap-4 mt-2 justify-center items-center pb-2">
                        {Array.isArray(GameItems) && GameItems.length > 0 ? (
                            GameItems.map((item, index) => (
                                <div
                                    key={index}
                                    className="w-[358px] sm:w-[358px] lg:w-[358px] xl:w-[358px] lg:p-4 h-[98px]"
                                >
                                    <div
                                        className="flex bg-[#151521] border border-[#2d2d38] w-[358px] h-[98px] text-white p-4 rounded-[8px] shadow-[rgba(0,0,28,.08)_0_2px_28px,rgba(0,0,28,.16)_0_0_1px] transition-transform duration-200 ease-in-out transform hover:bg-[#2631fb] hover:scale-105 active:scale-95 cursor-pointer"
                                        onClick={() => toUrl(item.link)}
                                    >
                                        <div className="w-full flex items-center">
                                            <div className="rounded w-20 h-20 flex-shrink-0">
                                                <img
                                                    src={
                                                        item.image_url && item.image_url.includes('https')
                                                            ? item.image_url
                                                            : `${item.image_url ? item.image_url : ' '}`
                                                    }
                                                    alt="icon"
                                                    className="object-cover rounded-lg h-full w-full"
                                                />
                                            </div>
                                            <div className="w-full ml-3">
                                                <p className="text-lg text-white with-dot w-60 break-words line-clamp-2 mt-1 flex items-center justify-between">
                                                    {item.name ? item.name : '-'}
                                                    {item.source === 'internal' && (
                                                        <img src={hot} className="w-6 h-full" alt="" />
                                                    )}
                                                </p>
                                                <p className="text-base text-[#8e8e93] with-dot w-[206px] break-words line-clamp-1 mt-1">
                                                    {item.description ? item.description : '-'}
                                                </p>
                                                <img src={wfj} alt="" className="w-5 h-5 mt-2" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            ""
                        )}
                    </div>
                </div> */}

                {/* new web */}
                <div className='sm:block hidden'>
                    <div className="w-full max-w-screen-xl flex flex-col ">
                        <div className="p-2 rounded-[20px] border-[9px] border-[#3633F7] bg-gradient-to-r from-[#181774] via-[#B5B5D6] to-[#0E0C59] relative">
                            <Swiper
                                modules={[Autoplay]}  // 只需要Autoplay模块
                                pagination={{ clickable: true }}  // 分页器可点击
                                loop={true}  // 循环播放
                                autoplay={{
                                    delay: 3000,  // 每隔3秒切换
                                    disableOnInteraction: false,  // 用户交互后仍然会继续自动播放
                                }}
                                className="mySwiper "  // 让Swiper宽高都为100%
                                slidesPerView={1}  // 只显示一个幻灯片
                                spaceBetween={20}  // 幻灯片之间的间距
                            >
                                <SwiperSlide>
                                    <div className='cursor-pointer' onClick={() => window.open("https://t.me/TCatGame_Bot/game", "_blank")}>
                                        <img src={tcat} alt="Banner" className="w-full h-full object-cover" />
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='cursor-pointer' onClick={() => window.open("https://game.bitball.io", "_blank")}>
                                        <img src={bitball} alt="Banner" className="w-full h-full object-cover" />
                                    </div>
                                </SwiperSlide>
                            </Swiper>

                            <img src={slidecon} alt="" className="w-[754px] h-[126px] absolute bottom-[-80px] left-[50%] transform -translate-x-[50%] z-[2]" />
                        </div>


                        <div className='w-[1328px] h-[400px] mt-[103px] p-2'>
                            <p className='flex items-center '><img src={topgames} alt="" className='w-[54px] h-[54px]' /> <span className='text-3xl text-white ml-[16px] font-semibold'>Top Games</span> </p>
                            <div className='w-full h-[227px]  mt-9 flex justify-around'>
                                {Array.isArray(TopGameItems) && TopGameItems.length > 0 ? (
                                    TopGameItems.map((item, index) => (
                                        <div key={index} className='p-4 w-[424px] h-full rounded-[14px] border-[2px] border-[#3633F7] bg-[#242424] shadow-[inset_0px_0px_81.6px_9px_#3633F7] flex relative cursor-pointer' onClick={() => toUrl(item.link)} >
                                            <div className='mt-3'>
                                                <img src={item.sort == 1 ? num1 : item.sort == 2 ? num2 : num3} alt="" className='w-auto h-[57px]' />
                                                <div className='mt-4 ml-1'>
                                                    <p className='text-white text-lg'>{item.name}</p>
                                                    <p className='text-base text-[#979797]  with-dot w-[150px] break-words line-clamp-1'>{item.description}</p>
                                                    {/* <img src={wfj} alt="" className='w-[20px] mt-2 cursor-pointer' onClick={() => toUrl(item.link)} /> */}
                                                </div>
                                            </div>
                                            <div className='w-[234px] h-[234px] absolute right-[8px] top-[-7px] rounded-[14px] border-[2px] border-[#3633F7]'>
                                                <img src={
                                                    item.image_url && item.image_url.includes('https')
                                                        ? item.image_url
                                                        : `${item.image_url ? item.image_url : ' '}`
                                                } alt="" className='w-full h-full rounded-[14px] cursor-pointer' onClick={() => toUrl(item.link)} />
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>


                        <div className='w-[1328px]  p-2'>
                            <p className='flex items-center '>
                                <img src={hottest} alt="" className='w-[58px] h-[40px]' />
                                <span className='text-3xl text-white ml-[16px] font-semibold'>Hottest</span>
                            </p>
                            <div className='w-full  mt-9 flex flex-wrap gap-[16px] justify-start'>
                                {HottestGameItems.map((item, index) => (
                                    <div key={index} className='w-full h-auto max-w-60  rounded-[14px]   cursor-pointer' onClick={() => toUrl(item.link)}  >
                                        <img src={
                                            item.image_url && item.image_url.includes('https')
                                                ? item.image_url
                                                : `${item.image_url ? item.image_url : ' '}`
                                        } alt="" className='rounded-[14px]' />
                                    </div>
                                ))}
                            </div>
                        </div>


                        <div className='w-[1328px]  p-2 mt-3'>
                            <p className='flex items-center '>
                                <img src={latest} alt="" className='w-[58px] h-[40px]' />
                                <span className='text-3xl text-white ml-[16px] font-semibold'>Latest</span>
                            </p>
                            <div className='w-full  mt-9 flex flex-wrap gap-[16px] justify-start'>
                                {LatestGameItems.map((item, index) => (
                                    <div
                                        key={index}
                                        className="w-full h-auto max-w-60  cursor-pointer rounded-[14px]"
                                        onClick={() => toUrl(item.link)}
                                    >
                                        <img
                                            src={
                                                item.image_url && item.image_url.includes('https')
                                                    ? item.image_url
                                                    : `${item.image_url ? item.image_url : ' '}`
                                            }
                                            alt=""
                                            className="w-full h-auto rounded-[14px]"
                                        />
                                    </div>
                                ))}

                            </div>
                        </div>


                        <div className='w-[1328px]  p-2  mt-3 mb-3'>
                            <p className='flex items-center '>
                                <img src={trending} alt="" className='w-[58px] h-[40px]' />
                                <span className='text-3xl text-white ml-[16px] font-semibold'>Trending</span>
                            </p>
                            <div className='w-full  mt-9 flex flex-wrap gap-[16px] justify-start'>
                                {TrendingGameItems.map((item, index) => (
                                    <div key={index} className='w-full h-auto max-w-60 rounded-[14px]   cursor-pointer' onClick={() => toUrl(item.link)}  >
                                        <img src={
                                            item.image_url && item.image_url.includes('https')
                                                ? item.image_url
                                                : `${item.image_url ? item.image_url : ' '}`
                                        } alt="" className='rounded-[14px]' />
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                    <ChatgptComponent greetingMessage="Welcome to the Game Gallery. Pick one, dive in, no second thoughts." />
                </div>

                {/* new app */}
                <div className='sm:hidden block'>
                    <div className='w-[100vw] h-[122px] p-1'>
                        <div className="p-1.5 rounded-[10px] border-[3px] border-[#3633F7] bg-gradient-to-r from-[#181774] via-[#B5B5D6] to-[#0E0C59] relative">
                            <Swiper
                                modules={[Autoplay]}  // 只需要Autoplay模块
                                pagination={{ clickable: true }}  // 分页器可点击
                                loop={true}  // 循环播放
                                autoplay={{
                                    delay: 3000,  // 每隔3秒切换
                                    disableOnInteraction: false,  // 用户交互后仍然会继续自动播放
                                }}
                                className="mySwiper "  // 让Swiper宽高都为100%
                                slidesPerView={1}  // 只显示一个幻灯片
                                spaceBetween={20}  // 幻灯片之间的间距
                            >
                                <SwiperSlide>
                                    <div className='cursor-pointer' onClick={() => window.open("https://t.me/TCatGame_Bot/game", "_blank")}>
                                        <img src={tcat} alt="Banner" className="w-full h-full object-cover" />
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='cursor-pointer' onClick={() => window.open("https://game.bitball.io", "_blank")}>
                                        <img src={bitball} alt="Banner" className="w-full h-full object-cover" />
                                    </div>
                                </SwiperSlide>
                            </Swiper>

                            <img src={slidecon} alt="" className="w-[754px] h-[52.77px] absolute bottom-[-35px] left-[50%] transform -translate-x-[50%] z-[2]" />
                        </div>
                    </div>


                    <div className="w-full mt-20 p-2 flex justify-center">
                        <div className="max-w-full w-full">
                            <p className="flex items-center">
                                <img src={topgames} alt="" className="w-[54px] h-[54px]" />
                                <span className="text-lg text-white ml-[16px] font-semibold">Top Games</span>
                            </p>
                            <div className="w-full">
                                {Array.isArray(TopGameItems) && TopGameItems.length > 0 ? (
                                    TopGameItems.map((item, index) => (
                                        <div
                                            key={index}
                                            className="mt-4 max-w-full rounded-[14px] border-[2px] border-[#3633F7] bg-[#242424] shadow-[inset_0px_0px_81.6px_9px_#3633F7] relative cursor-pointer"
                                            onClick={() => toUrl(item.link)}
                                        >
                                            <div className="mt-3 flex items-center ml-5">
                                                <img
                                                    src={item.sort == 1 ? num1 : item.sort == 2 ? num2 : num3}
                                                    alt=""
                                                    className="w-auto h-[57px]"
                                                />
                                                <div className="mt-4 ml-3">
                                                    <p className="text-white text-lg">{item.name}</p>
                                                    <p className="text-base text-[#979797] with-dot w-[150px] break-words line-clamp-1">
                                                        {item.description}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='w-full h-[100px]  mt-3'>
                                                <div className=' rounded-[14px] border-[2px] border-[#3633F7]'>
                                                    <img src={
                                                        item.image_web && item.image_web.includes('https')
                                                            ? item.image_web
                                                            : `${item.image_web ? item.image_web : ' '}`
                                                    } alt="" className='w-full h-full rounded-[14px] cursor-pointer' onClick={() => toUrl(item.link)} />
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="w-full mt-3 p-2 ">
                        <p className='flex items-center '>
                            <img src={hottest} alt="" className='w-[58px] h-[40px]' />
                            <span className='text-lg text-white ml-[16px] font-semibold'>Hottest</span>
                        </p>
                        <div className="w-full mt-5">
                            <div className="grid grid-cols-3 gap-2">
                                {HottestGameItems.map((item, index) => (
                                    <div
                                        key={index}
                                        className="mb-4 rounded-[14px]  cursor-pointer"
                                        onClick={() => toUrl(item.link)}
                                    >
                                        <img
                                            src={
                                                item.image_url && item.image_url.includes('https')
                                                    ? item.image_url
                                                    : `${item.image_url ? item.image_url : ' '}`
                                            }
                                            alt=""
                                            className="w-full h-auto rounded-[14px]"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>


                    </div>

                    <div className="w-full mt-3 p-2 ">
                        <p className='flex items-center '>
                            <img src={latest} alt="" className='w-[58px] h-[40px]' />
                            <span className='text-lg text-white ml-[16px] font-semibold'>Latest</span>
                        </p>
                        <div className="w-full mt-5">
                            <div className="grid grid-cols-3 gap-2">
                                {LatestGameItems.map((item, index) => (
                                    <div
                                        key={index}
                                        className="w-full h-auto max-w-60  cursor-pointer rounded-[14px]"
                                        onClick={() => toUrl(item.link)}
                                    >
                                        <img
                                            src={
                                                item.image_url && item.image_url.includes('https')
                                                    ? item.image_url
                                                    : `${item.image_url ? item.image_url : ' '}`
                                            }
                                            alt=""
                                            className="w-full h-auto rounded-[14px]"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>


                    </div>


                    <div className="w-full mt-3 p-2 ">
                        <p className='flex items-center '>
                            <img src={trending} alt="" className='w-[58px] h-[40px]' />
                            <span className='text-lg text-white ml-[16px] font-semibold'>Trending</span>
                        </p>
                        <div className="w-full mt-5">
                            <div className="grid grid-cols-3 gap-2">
                                {TrendingGameItems.map((item, index) => (
                                    <div key={index} className='w-full h-auto max-w-60 rounded-[14px]  cursor-pointer' onClick={() => toUrl(item.link)}  >
                                        <img src={
                                            item.image_url && item.image_url.includes('https')
                                                ? item.image_url
                                                : `${item.image_url ? item.image_url : ' '}`
                                        } alt="" className='rounded-[14px]' />
                                    </div>
                                ))}
                            </div>
                        </div>


                    </div>
                    <ChatgptComponent greetingMessage="Welcome to the Game Gallery. Pick one, dive in, no second thoughts." />
                </div>
            </div>


        </div >
    )
}

export default Games;
